
import SoftwareHouseDetails from '../components/SoftwareHouseDetails.vue'
import { defineComponent } from 'vue'
import SessionService from '../SessionService'
import api from '@/services/api'

export default defineComponent({
  name: 'Profile',
  components: {
    SoftwareHouseDetails
  },
  data () {
    return {
      softwareHouse: {
        status: '',
        data: {}
      },
      SOFTWARE_HOUSE_CNPJ: null,
      isFinished: false,
      mediatorFee: 0,
      loading: false
    }
  },
  created () {
    const session = new SessionService()
    this.SOFTWARE_HOUSE_CNPJ = session.cnpj()
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      this.isFinished = false

      const preRegister = await api.get(`/pre-register/software-house/${this.SOFTWARE_HOUSE_CNPJ}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      const softwareHouseByCnpj = await api.get('/software-houses/accounts/my', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })

      this.softwareHouse = {
        status: softwareHouseByCnpj.data.status,
        data: {
          ...softwareHouseByCnpj.data,
          preRegister: preRegister.data

        }
      }
      this.mediatorFee = softwareHouseByCnpj.data.mediatorFee

      if (this.softwareHouse.status !== 'cadastro_solicitado') {
        this.alreadyRegistered = true
      }

      if (this.softwareHouse.status === 'cadastro_concluido') {
        this.isFinished = true
      }

      this.loading = false
    }
  },
  beforeMount () {
    this.$store.commit('changeActiveMenu', 6)
  }
})
